

/*--------------      Loader      --------------*/

$(window).load(function() {
	$("#status").fadeOut();
	$("#preloader").delay(1000).fadeOut("slow");
  	bannerResize();
});
$(window).on('resize',function(){
	bg_collection_img();
  	bannerResize();
});

function bannerResize(){
  var minAspectRatio = $('[min-aspect-ratio]').attr('min-aspect-ratio');
  minAspectRatio = (1 / minAspectRatio) * 100; 
  //   minAspectRatio =  minAspectRatio < 150 ? (minAspectRatio + ((minAspectRatio * 24.3)/100)) : minAspectRatio;
  minAspectRatio = $(document).width() < 768 ? ( $('.slideshow__text-content').outerHeight() + minAspectRatio) : minAspectRatio;
  $('[min-aspect-ratio]').css('padding-top',minAspectRatio+'%');
  return 0;
}
function silder_top_posiion()
{
  /* Silder Caption When class Vtop */

  if($('.slider-caption').hasClass('Vtop'))
  {
    $('.slider-caption').css("top", $('header').innerHeight() + $('.utility_nav').innerHeight()+"px");
  }

}

$(document).ready(function() {  
  silder_top_posiion();
  bannerResize();
   /*------------ IMG Zoom Effect --------------------*/
  $('#ex1').zoom();
  

	if(navigator.userAgent.indexOf('Mac') > 0){
		$('body').addClass('mac-os');
	}

    /*--------------      Active Nav      --------------*/

    var path = location.pathname.substring(1);
    if (path) {
        $('.mobile-menu ul a[href$="' + path + '"]').parent().addClass('selected');
    };

    /*--------------      Mobile Menu      --------------*/

    var WindowHeight = $(window).innerHeight() - $('header').innerHeight();
    $('.header-menu').css('height', WindowHeight);

    if( $(window).width() <= 767 ){
      var WindowHeight = $(window).innerHeight() - $('header').innerHeight();
      $('.filter-menu').css('height', WindowHeight);
    }
  
    $(".bar-icon").on("click", function(event) {
        $('.inner-wrap').toggleClass('menu-open');
		
		if ( $('.inner-wrap').hasClass('menu-short') ){
			$('.inner-wrap').removeClass('menu-short')
		}		
    });
	
	$(".short").on("click", function(event) {
        $('.inner-wrap').toggleClass('menu-short');
		if ( $('.inner-wrap').hasClass('menu-open') ){
			$('.inner-wrap').removeClass('menu-open')
		}
    });

    /*--------------      Filter Menu      --------------*/

    $('.filter .parent-submenu').click(function(e) {
        $(this).find('.dropdown').slideToggle();
    });

    /*--------------      Load More      --------------*/
  
    if ( $('.shop ul.shop-list li, .home-product ul.shop-list li').size() == 0 ){
      $('.shop #loadMore, .home-product #loadMore').hide();          
    }
  
	if( $(window).width() >= 1200 ){
		 		 
		var shop_sizeli = $(".shop ul.shop-list li").size();
		var shop_x = 36;
		$('.shop ul.shop-list li:lt(' + shop_x + ')').show();
		$('.shop #loadMore').click(function() {
			shop_x = (shop_x + 12 <= shop_sizeli) ? shop_x + 12 : shop_sizeli;
			$('.shop ul.shop-list li:lt(' + shop_x + ')').show();

			if (shop_x == shop_sizeli) {
				$('.shop #loadMore').hide();
			}
			return false;
		});
      
        if( $('.shop ul.shop-list li').size() >= 37 ){
          $('.shop #loadMore').show();
        }
        else{
          $('.shop #loadMore').hide();          
        }
	 }
	
	 if( $(window).width() >= 1200 ){
		 		 
		var sizeli = $(".home-product ul.shop-list li").size();
		var x = 12;
		$('.home-product ul.shop-list li:lt(' + x + ')').show();
		$('.home-product #loadMore').click(function() {
			x = (x + 12 <= sizeli) ? x + 12 : sizeli;
			$('.home-product ul.shop-list li:lt(' + x + ')').show();

			if (x == sizeli) {
				$('.home-product #loadMore').hide();
			}
			return false;
		});
         if( $('.home-product ul.shop-list li').size() >= 13 ){
           $('.home-product #loadMore').show();          
         }
         else{
           $('.home-product #loadMore').hide();           
         }
	 }
	
	if(  $(window).width() <= 1199 && $(window).width() >= 969 ){
			
		var sizeli = $("ul.shop-list li").size();
		var x = 10;
		$('ul.shop-list li:lt(' + x + ')').show();
		$('#loadMore').click(function() {
			x = (x + 10 <= sizeli) ? x + 10 : sizeli;
			$('ul.shop-list li:lt(' + x + ')').show();
	
			if (x == sizeli) {
				$('#loadMore').hide();
			}
			return false;
		});
	
	}
	
	if(  $(window).width() <= 968 && $(window).width() >= 769 ){
			
		var sizeli = $("ul.shop-list li").size();
		var x = 8;
		$('ul.shop-list li:lt(' + x + ')').show();
		$('#loadMore').click(function() {
			x = (x + 8 <= sizeli) ? x + 8 : sizeli;
			$('ul.shop-list li:lt(' + x + ')').show();
	
			if (x == sizeli) {
				$('#loadMore').hide();
			}
			return false;
		});
	
	}
	
	if(  $(window).width() <= 768 && $(window).width() >= 641 ){
			
		var sizeli = $("ul.shop-list li").size();
		var x = 9;
		$('ul.shop-list li:lt(' + x + ')').show();
		$('#loadMore').click(function() {
			x = (x + 9 <= sizeli) ? x + 9 : sizeli;
			$('ul.shop-list li:lt(' + x + ')').show();
	
			if (x == sizeli) {
				$('#loadMore').hide();
			}
			return false;
		});
	
	}
	
	if(  $(window).width() >= 0 && $(window).width() <= 640 ){
			
		var sizeli = $("ul.shop-list li").size();
		var x = 8;
		$('ul.shop-list li:lt(' + x + ')').show();
		$('#loadMore').click(function() {
			x = (x + 4 <= sizeli) ? x + 4 : sizeli;
			$('ul.shop-list li:lt(' + x + ')').show();
	
			if (x == sizeli) {
				$('#loadMore').hide();
			}
			return false;
		});
	
	}
    

    /*--------------      Qty      --------------*/

	$('.minus').on('click', function() {		
		var count = $(this).siblings(".qty");
		var val = parseInt(count.val());
		if (val > 1)
			count.val(val - 1);
	});
	$('.plus').on('click', function() {		
		var count = $(this).siblings(".qty");
		var val = parseInt(count.val());
		count.val(val + 1);
	});
	
	/*--------------      Search      --------------*/
	
	$('.search-btn').on('click', function() {
		$('.search-form').show();
      	$('.search-form').addClass('search-sticky'); 
	});
	
	$('.close-search').on('click', function() {
		$('.search-form').hide();
      	$('.search-form').removeClass('search-sticky'); 
	});
	
	/*$('.cart-btn').on('click', function() {
		$('.cart-popup').toggle();
	});*/
	
    /*--------------      Bg Image      --------------*/
	
	function setHeight() {
		windowHeight = $(window).innerHeight();
		//$('.home-slider ul li').css('height', windowHeight);
	};
	setHeight();
	
	$(window).resize(function() {
		setHeight();
        s_bg_img();
		silder_top_posiion()
	});
  
  function s_bg_img(){
      if($(window).width() >= 769 )
      {
        jQuery('.slider-img').each(function() {

            var el = $(this),
                src = el.attr('src'),
                parent = el.parent(),
                height = $(window).height();

            parent.css({
                'background-image': 'url(' + src + ')',
                'background-size': 'cover',
                'background-position': 'center',
                'height': height
            });

            el.hide();
        });
      }
      else
      {
        jQuery('.slider-img_2').each(function() {

            var el = $(this),
                src = el.attr('src'),
                parent = el.parent(),
                height = $(window).height();

            parent.css({
                'background-image': 'url(' + src + ')',
                'background-size': 'cover',
                'background-position': 'center',
                'height': height
            });

            el.hide();
        });
      }
 }
	s_bg_img();
	if( $(window).width() > 641 ){      
		
		jQuery('.bg-img').each(function() {
		
			var el = $(this),
				src = el.attr('src'),
				parent = el.parent(),
				height = el.width();
		
			parent.css({
				'background-image': 'url(' + src + ')',
				'background-size': 'cover',
				'background-position': 'center',
				'height': height
			});
		
			el.hide();
		});
	}
  
  
 	
	/*--------------      Page content      --------------*/
	
	var header = $('header').innerHeight();
	var footer = $('footer').innerHeight();
	var windows = $(window).innerHeight();
	var sum = parseInt(header) + parseInt(footer);
	$('#MainContent').css('min-height',windows - sum );
		
    /*--------------      Home Slider      --------------*/
	
	$('.home-slider ul').slick({
		dots: false,
		speed: 1200,
		arrows: false,
		slidesToShow: 1,
		autoplay: true,
		autoplaySpeed: 3000,
		touchMove: true,
		infinite: true,
		slide: 'li'
	});
	
    /*--------------      Related Product      --------------*/
	
	$('.related-product ul').slick({
		dots: false,
		speed: 1200,
		arrows: false,
		slidesToShow: 5,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 3000,
		touchMove: true,
		infinite: true,
		slide: 'li',
		responsive: [{
				breakpoint: 1024,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 567,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
		]
	});
		
		
	/*--------------      End      --------------*/
  
  
  /*$('.product_wrapper').slick({
    arrows: true,
    infinite: true,
    speed: 1000,
    slide: 'li',
    slidesToShow: 5,
    adaptiveHeight: true,
    autoplay: true,
    dots: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 969,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 641,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }


    ]
  });*/
  
  
  bg_collection_img();

});

/*--------------      MagnificPopup      --------------*/

if( $(window).width() <= 768 ){

  $('.lookbook a').click(function(e) {
    return false;
  });
}

$('.lookbook').magnificPopup({
  disableOn: 769,
  delegate: 'a',
  type: 'image',
  tLoading: 'Loading image #%curr%...',
  mainClass: 'mfp-img-mobile',
  gallery: {
    enabled: true,
    navigateByImgClick: true,
    preload: [0,1] // Will preload 0 - before current, and 1 after the current image
  } 
});

if( $(window).width() <= 640 ){

  $('.poplet a, .large-img a').click(function(e) {
    return false;
  });
}
$('.poplet').magnificPopup({
  disableOn: 641,
  delegate: 'a',
  type: 'image',
  tLoading: 'Loading image #%curr%...',
  mainClass: 'mfp-img-mobile',
  gallery: {
    enabled: true,
    navigateByImgClick: true,
    preload: [0,1] // Will preload 0 - before current, and 1 after the current image
  } 
});

$('.large-img').magnificPopup({
  disableOn: 641,
  delegate: 'a',
  type: 'image',
  closeOnContentClick: true,
  mainClass: 'mfp-img-mobile',
  image: {
    verticalFit: true
  }

});

/*--------------      Header Fix      --------------*/

$(document).scroll(function() {
	var navHeight = $("header").innerHeight(); 
	var y = $(document).scrollTop(), 
	header = $("header"); 
 	if(y >= 1){
			if( parseInt($(window).height()+navHeight+111) < parseInt($('html').height()) ){
				header.addClass('stickytop'); 
                $('.filter-menu').addClass('filter_stickytop'); 
			}
		} 
		else {
			header.removeClass('stickytop');
            $('.filter-menu').removeClass('filter_stickytop'); 
		} 
});

function bg_collection_img(){
  jQuery('.bg-img-coll').each(function() {

    var el = $(this),
        src = el.attr('src'),
        parent = el.parent(),
        height = el.height();

    parent.css({
      'background-image': 'url(' + src + ')',
      'background-size': 'cover',
      'background-position': 'center',
      'height': height
    });

    el.hide();
  })
}


$(document).on('click','.has-dropdown>.site-nav__link',function(e){
  if($(window).width() < 768 ){
    var _this = $(this);
    _this.toggleClass('active');
    e.preventDefault();
    $(this).next().slideToggle();
    setTimeout(function(){
      var _parentHeight = _this.closest('.menu').height() + 73 , _grandParentHeight = _this.closest('.mobile-menu-wrapper').height();
      if( _parentHeight > _grandParentHeight  ){ _this.closest('.menu').addClass('dropdown-open');
      }else{ _this.closest('.menu').removeClass('dropdown-open'); }
    },500)
  }
});

$( document ).ready(function() {
  $( ".onclick_down" ).click(function() {
    $(".onclick_scroll").slideToggle();
  });
});

 
  /*
    if( $(window).width() >= 1200 ){
      $(".home-product .list").kp_load_more({
        elements: 'li',
        load_data:12,
        per_page: 12,
        json_url: 'https://christopher-kon.myshopify.com/admin/products.json',
        shopify: true
      });
    }
  
    if( $(window).width() >= 1200 ){
      $(".shop .list").kp_load_more({
        elements: 'li',
        load_data:36,
        per_page: 12,
        json_url: 'https://christopher-kon.myshopify.com/admin/products.json',
        shopify: true
      });
    }
  
    if( $(window).width() <= 1199 && $(window).width() >= 969 ){
      $(".list").kp_load_more({
        elements: 'li',
        load_data:10,
        per_page: 10,
        json_url: 'https://christopher-kon.myshopify.com/admin/products.json',
        shopify: true
      });
    }
  
  if(  $(window).width() <= 968 && $(window).width() >= 769 ){
      $(".list").kp_load_more({
        elements: 'li',
        load_data:8,
        per_page: 8,
        json_url: 'https://christopher-kon.myshopify.com/admin/products.json',
        shopify: true
      });
    }
	
   if(  $(window).width() <= 768 && $(window).width() >= 641 ){
      $(".list").kp_load_more({
        elements: 'li',
        load_data:9,
        per_page: 9,
        json_url: 'https://christopher-kon.myshopify.com/admin/products.json',
        shopify: true
      });
    }
  
  if(  $(window).width() >= 0 && $(window).width() <= 640 ){
      $(".list").kp_load_more({
        elements: 'li',
        load_data:8,
        per_page: 8,
        json_url: 'https://christopher-kon.myshopify.com/admin/products.json',
        shopify: true
      });
    }
*/